module.exports = __webpack_public_path__ + "static/media/paredes_vivas_6.e9092367.jpg";